export const SCHEME_CODE = 'NBSHospitality';
export const MASTER_CODE = 'NBSHospitality';

export const OCCUPATION_FAMILY_CODE_REST = 'Restaurant & Takeaway';
export const OCCUPATION_FAMILY_CODE_PUB = 'Hospitality';
